import { BaseModel } from "@blue-chip/core";

export default class ProjectAreaPrice extends BaseModel {}
